import { inject, Injectable } from '@angular/core';
import { SpinnerService } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class FilesUtility {
  #spinner = inject(SpinnerService);
  getFileIcon(type: string): string {
    if (type === 'folder') return 'folder';
    const extension = type.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'doc':
      case 'docx':
        return 'word';
      case 'xls':
      case 'xlsx':
        return 'excel';
      case 'ppt':
      case 'pptx':
        return 'powerpoint';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      case 'mp4':
      case 'avi':
      case 'mov':
        return 'video';
      default:
        return 'file';
    }
  }

  formatFileSize(size: string): string {
    const bytes = parseInt(size);
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  getFilePath(filePath: string): string {
    let path = filePath?.replace(/\//g, '   >   ');
    let lastSeparatorIndex = path?.lastIndexOf('   >   ');
    let parentPath = path?.substring(0, lastSeparatorIndex);
    return parentPath;
  }

  getFileExtension(file: any): string {
    return `${file?.name.split('.').pop().toLowerCase()}`;
  }

  downloadFileFromUrl(url: string, filename: string): void {
    this.#spinner.handleSpinnerStart();
    fetch(url)
      .then(response => {
        if (!response.ok) {
          this.#spinner.handleSpinnerStop();
          throw new Error(`Download request failed with status ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
        this.#spinner.handleSpinnerStop();
      })
      .catch(error => {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.#spinner.handleSpinnerStop();
      });
  }
}
